<!--
 *
 * Copyright © 2017 Easymeeting AS. All rights reserved.
 *
 * This software is produced by Easymeeting AS.
 * Unauthorized redistribution, reproduction, or usage of
 * this software in whole or in part without the express
 * written consent of Easymeeting AS is strictly prohibited.
-->
<template>
  <!-- User Card Tile -->
  <div
    v-if="contact.profilepic"
    class="card easy-profile-card"
    :class="{animate:animate}"
    :style="{backgroundImage: `url('${contact.profilepic}')`}"
    :data-qa="dataQa"
  />
  <div
    v-else
    class="card easy-profile-card"
    :class="[{animate:animate} ,contact.profilepic ? '' : `bg-color-${colorCode}`]"
    :data-qa="dataQa"
  >
    <h1
      class="center-name"
      :data-qa="`${dataQa}_contact_name`"
    >
      {{ firstName }}
    </h1>
  </div>
</template>

<script>
import contactMixin from '@/mixins/contact';
export default {
  name: 'ContactLiteCard',
  mixins: [contactMixin],
  props: {
    contact: {
      type: Object,
      default: null
    },
    animate: {
      type: Boolean,
      default: false
    },
    dataQa: {
      type: String,
      default: null
    }
  },
  computed: {
    firstName () {
      if (this.contact.protocol === 'h323' || this.contact.protocol === 'sip') {
        if (this.contact.fromid) {
          return this.contact.fromid;
        }
      }
      if (this.contact.name) {
        return (this.contact.name ? this.contact.name.split(' ')[0] : '');
      }
      if (this.contact.alias) {
        return this.contact.alias;
      }
      if (this.contact.fname) {
        return this.contact.fname;
      }
      if (this.contact.displayName) {
        return (this.contact.displayName ? this.contact.displayName.split(' ')[0] : '');
      }
      return '';
    }
  }
};
</script>
